'use strict';

var directivesList = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'dialogSearchHelper',
	'accountStructureService',
	'vendorService',
	'employeeService',
	'BUSY_MESSAGE',
];
apInvoiceAgingController.$inject = directivesList;
angular.module('schoolLinqApp').controller('apInvoiceAgingController', apInvoiceAgingController);

function apInvoiceAgingController(
	$scope,
	$rootScope,
	$q,
	$interval,
	dialogHelper,
	reportHelper,
	dialogSearchHelper,
	accountStructureService,
	vendorService,
	employeeService,
	BUSY_MESSAGE
) {
	$scope.vm = getViewModel($rootScope.mode || 'fund');

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.busyPromise = $q.all([$scope.vm.loadFunds($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			vendors: [{ Id: 0, Description: 'All Vendors' }],
			employees: [{ Id: 0, Description: 'All Employees' }],
			reportTypes: [
				{ Id: 0, Description: 'By Account' },
				{ Id: 1, Description: 'By Vendor Name' },
				{ Id: 2, Description: 'By Vendor Code' },
			],
			dateUseTypes: [
				{ Id: 0, Description: 'Due Date' },
				{ Id: 1, Description: 'Invoice Date' },
				{ Id: 2, Description: 'Post Date' },
			],
			summaryTypes: [
				{ Id: 0, Description: 'Detail Report' },
				{ Id: 1, Description: 'Summary Report' },
			],
			fundsCheckAll: true,
			fundsLeft: [],
			fundsMiddle: [],
			fundsRight: [],
			filter: {
				reportType: 0,
				dateUseType: 0,
				summaryType: 0,
				asOfDT: moment().toDate(),
				payrollOnly: false,
				omitPayroll: false,
				reimbursementsOnly: false,
				omitReimbursements: false,
				venOrEmp: 'Vendor',
				vendorId: 0,
				employeeId: 0,
			},

			errors: null,
			validationErrors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.filter.asOfDT) {
				model.filter.asOfDT = moment().toDate();
			}

			let isOneSelected = false;
			let arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
			angular.forEach(arrFunds, function (funds) {
				if (isOneSelected === false) {
					isOneSelected = _.some(funds, function (obj) {
						return obj.Selected === true;
					});
				}
			});

			if (isOneSelected === false) {
				model.validationErrors.push('Please select one or more Funds to include in Invoice Aging.');
				isValid = false;
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('AP Invoice Aging Report Error!', '', model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var fundsSelected = [];

			//get selected funds
			if (model.fundsCheckAll === true) {
				fundsSelected.push({ Id: 0, Description: 'All' });
			} else {
				let arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
				angular.forEach(arrFunds, function (funds) {
					angular.forEach(funds, function (obj) {
						if (obj.Selected === true) {
							let obj2 = { Id: obj.Id, Description: obj.Description };
							fundsSelected.push(obj2);
						}
					});
				});
			}

			var report = {
				ReportType: model.filter.reportType || 0,
				AsOfDT: model.filter.asOfDT,
				DateUseType: model.filter.dateUseType || 0,
				PayrollOnly: model.filter.payrollOnly,
				OmitPayroll: model.filter.omitPayroll,
				ReimbursementsOnly: model.filter.reimbursementsOnly,
				OmitReimbursements: model.filter.omitReimbursements,
				VendorId: model.filter.vendorId || 0,
				EmployeeId: model.filter.employeeId || 0,
				SummaryType: model.filter.summaryType || 0,
				FundsCol: fundsSelected,
			};

			reportHelper.postReport($scope, '/api/fundreports/apinvoiceagingreport', report, 'APInvoiceAgingReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('AP Invoice Aging Error!', '', model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var fundsSelected = [];

			//get selected funds
			if (model.fundsCheckAll === true) {
				fundsSelected.push({ Id: 0, Description: 'All' });
			} else {
				let arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
				angular.forEach(arrFunds, function (funds) {
					angular.forEach(funds, function (obj) {
						if (obj.Selected === true) {
							let obj2 = { Id: obj.Id, Description: obj.Description };
							fundsSelected.push(obj2);
						}
					});
				});
			}

			var report = {
				ReportType: model.filter.reportType || 0,
				AsOfDT: model.filter.asOfDT,
				DateUseType: model.filter.dateUseType || 0,
				PayrollOnly: model.filter.payrollOnly,
				OmitPayroll: model.filter.omitPayroll,
				ReimbursementsOnly: model.filter.reimbursementsOnly,
				OmitReimbursements: model.filter.omitReimbursements,
				VendorId: model.filter.vendorId || 0,
				EmployeeId: model.filter.employeeId || 0,
				SummaryType: model.filter.summaryType || 0,
				FundsCol: fundsSelected,
			};

			reportHelper.postExcel($scope, '/api/fundreports/apinvoiceagingexcel', report, 'APInvoiceAging.xlsx');
		}

		function loadFunds(model) {
			return accountStructureService.getFunds().then(_.partial(finishLoadingFunds, model));

			function finishLoadingFunds(model, response) {
				var arrFunds = response.data.funds;

				var colSize = 3;
				if (arrFunds.length === 0) {
					return angular.noop;
				} else {
					let partialCol = arrFunds.length % 3 > 0 ? 1 : 0;
					colSize = parseInt(arrFunds.length / 3) + partialCol;
				}

				angular.forEach(arrFunds, function (f) {
					let obj = { Id: f, Description: f, Selected: true };
					if (model.fundsLeft.length < colSize) {
						model.fundsLeft.push(obj);
					} else if (model.fundsMiddle.length < colSize) {
						model.fundsMiddle.push(obj);
					} else if (model.fundsRight.length < colSize) {
						model.fundsRight.push(obj);
					}
				});

				return angular.noop;
			}
		}

		function manageCheckBoxes(model, checkBoxName) {
			switch (checkBoxName) {
				case 'payrollOnly':
					if (model.filter.payrollOnly === true) {
						model.filter.omitPayroll = false;
						model.filter.reimbursementsOnly = false;
						model.filter.omitReimbursements = false;
					}
					break;

				case 'omitPayroll':
					if (model.filter.omitPayroll === true) {
						model.filter.payrollOnly = false;
						model.filter.reimbursementsOnly = false;
					}
					break;

				case 'reimbursementsOnly':
					if (model.filter.reimbursementsOnly === true) {
						model.filter.vendorId = 0;
						model.filter.payrollOnly = false;
						model.filter.omitPayroll = false;
						model.filter.omitReimbursements = false;
					}
					break;

				case 'omitReimbursements':
					if (model.filter.omitReimbursements === true) {
						model.filter.payrollOnly = false;
						model.filter.reimbursementsOnly = false;
					}
					break;
			}

			model.filter.venOrEmp = 'Vendor';
			if (model.filter.reimbursementsOnly === true) {
				model.filter.venOrEmp = 'Employee';
			}
		}

		function fundSelectChange(model) {
			let leftIsSelected = _.every(model.fundsLeft, function (obj) {
				return obj.Selected === true;
			});

			let middleIsSelected = _.every(model.fundsMiddle, function (obj) {
				return obj.Selected === true;
			});

			let rightIsSelected = _.every(model.fundsRight, function (obj) {
				return obj.Selected === true;
			});

			model.fundsCheckAll = leftIsSelected === true && middleIsSelected === true && rightIsSelected === true;
		}

		function fundCheckAllChange(model) {
			angular.forEach(model.fundsLeft, function (f) {
				f.Selected = model.fundsCheckAll;
			});

			angular.forEach(model.fundsMiddle, function (f) {
				f.Selected = model.fundsCheckAll;
			});

			angular.forEach(model.fundsRight, function (f) {
				f.Selected = model.fundsCheckAll;
			});
		}

		function showDialogSearchHelperVendorsEmployees(model) {
			let modalConfig = {
				statusId: 0,
				statusesEnabled: true,
			};

			let selectFunction = null;

			if (model.filter.venOrEmp === 'Vendor') {
				selectFunction = function (vendor) {
					$scope.busyPromise = model.getVendor(vendor.Id);
				};

				dialogSearchHelper.searchVendors(modalConfig, selectFunction);
			} else {
				selectFunction = function (employee) {
					$scope.busyPromise = model.getEmployee(employee.Id);
				};

				dialogSearchHelper.searchEmployees(modalConfig, selectFunction);
			}
		}

		function getVendor(vendorId) {
			return vendorService.getVendor(vendorId).then(finishLoadingVendor);

			function finishLoadingVendor(response) {
				let vendor = response.data.vendor;

				if (!_.findWhere($scope.vm.vendors, { Id: vendorId })) {
					$scope.vm.vendors.push({
						Id: vendor.Id,
						Description: vendor.VendorName,
					});
				}

				$scope.vm.filter.vendorId = vendor.Id;

				return angular.noop;
			}
		}

		function getEmployee(employeeId) {
			return employeeService.get(employeeId).then(finishLoadingEmployee);

			function finishLoadingEmployee(response) {
				var employee = response.data.employee;

				if (!_.findWhere($scope.vm.employees, { Id: employee.Id })) {
					$scope.vm.employees.push({
						Id: employee.Id,
						Description: employee.FormattedFormalName + '  (' + employee.EmployeeNumber + ')',
					});
				}

				$scope.vm.filter.employeeId = employee.Id;

				return angular.noop;
			}
		}

		return angular.extend(model, {
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
			validateReportParams: _.partial(validateReportParams, model),
			loadFunds: _.partial(loadFunds, model),
			fundSelectChange: _.partial(fundSelectChange, model),
			fundCheckAllChange: _.partial(fundCheckAllChange, model),
			manageCheckBoxes: _.partial(manageCheckBoxes, model),
			showDialogSearchHelperVendorsEmployees: _.partial(showDialogSearchHelperVendorsEmployees, model),
			getVendor: getVendor,
			getEmployee: getEmployee,
		});
	}
}
